module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



// WEBPACK FOOTER //
// node_modules/_core-js@2.5.6@core-js/modules/_is-object.js